import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
export default function Copyright({ copyright, apStatement }) {
    const updatedCopyright = copyright
        ? copyright.replace(/-\d+/, `-${new Date().getFullYear()}`)
        : copyright;
    return (React.createElement(React.Fragment, null,
        React.createElement(RawHTML, { html: updatedCopyright }),
        React.createElement(RawHTML, { Tag: "ap-html", html: apStatement })));
}
